import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import css from "./TerAct.module.css";
import { ClinicContext } from "../../Context/ClinicContext";
import { Head } from "../../Utils/Head";
import { UserContext } from "../../Context/UserContext";
import { updateUserFirebase } from "../../Utils/firebaseUser";

export const KnowingYourPersonalStyle = () => {
  const { userData, setUserData } = useContext(UserContext);
  const {
    step,
    setStep,
    answer1,
    setAnswer1,
    answer2,
    setAnswer2,
    answer3,
    setAnswer3,
    answer4,
    setAnswer4,
    answer5,
    setAnswer5,
    answer6,
    setAnswer6,
  } = useContext(ClinicContext);
  const navigate = useNavigate();
  const stepLength = 11;

  useEffect(() => {
    setAnswer1("");
    setAnswer2("");
    setAnswer3("");
    setAnswer4("");
    setAnswer5("");
    setAnswer6("");
  }, []);

  const checkChoice = (choice) => {
    let counter = false;
    if (
      choice === answer1 ||
      choice === answer2 ||
      choice === answer3 ||
      choice === answer4 ||
      choice === answer5 ||
      choice === answer6
    ) {
      counter = true;
    } else {
      counter = false;
    }

    return counter;
  };

  const checkCorrects = () => {
    const traitList = [];
    let count = 0;

    Math.round((userData.personalityTraits[0] * 100) / 35) > 50
      ? answer1 === "affective" && count++
      : answer1 === "rational" && count++;
    Math.round((userData.personalityTraits[1] * 100) / 35) > 50
      ? answer2 === "active" && count++
      : answer2 === "contemplative" && count++;
    Math.round((userData.personalityTraits[2] * 100) / 35) > 50
      ? answer3 === "expansive" && count++
      : answer3 === "reserved" && count++;
    Math.round((userData.personalityTraits[3] * 100) / 40) > 50
      ? answer4 === "disciplined" && count++
      : answer4 === "spontaneous" && count++;
    Math.round((userData.personalityTraits[4] * 100) / 50) > 50
      ? answer5 === "imaginative" && count++
      : answer5 === "pragmatic" && count++;
    Math.round((userData.personalityTraits[4] * 100) / 50) > 50
      ? answer6 === "assertive" && count++
      : answer6 === "intense" && count++;

    return count;
  };

  const finish = () => {
    const updatedJourney = {
      level: 0,
      lesson: 4,
    };

    userData.journey = updatedJourney;
    setUserData(userData);
    updateUserFirebase(userData);
    setStep(0);
    navigate("/");
  };

  return (
    <div className={css.container}>
      <Head
        title="JourneyIntroduction"
        description={"SufferingAxis - Mairini"}
      />
      <section className={css.gridTop}>
        <i
          className={`material-icons ${css.topbarIcon}`}
          onClick={() => {
            setStep(0);
            navigate("/");
          }}
        >
          close
        </i>
        <div className={css.traitBar}>
          <div
            className={css.traitScore}
            style={{
              marginRight: `${((stepLength - step) * 100) / stepLength}%`,
            }}
          ></div>
        </div>
      </section>
      <section className={css.gridMain}>
        {step === 0 && (
          <div className={css.gridMainContainer}>
            <h1>Seu estilo único de ser</h1>
            <p>Cada pessoa funciona de um jeito.</p>
            <p>
              Alguns sentem tudo com intensidade. Outros preferem observar em
              silêncio.
            </p>
            <p>Alguns seguem o plano. Outros criam no improviso.</p>
            <p>Nenhuma dessas formas é certa ou errada.</p>
            <p>
              Aqui, você vai conhecer seis dimensões que te ajudam a entender
              melhor como você sente, pensa e age no mundo.
            </p>
          </div>
        )}
        {step === 1 && (
          <div className={css.gridMainContainer}>
            <p>
              Primeiro vamos conhecer sobre as dimensões do
              <span> Temperamento.</span>
            </p>
            <p>
              <span>
                🧬 Como você reage ao mundo de forma natural e automática.
              </span>
            </p>
          </div>
        )}
        {step === 2 && (
          <div className={css.gridMainContainer}>
            <h1>💓 Emoções</h1>
            <h1>Racional x Afetivo</h1>
            <p>
              Essa dimensão mostra o quanto as emoções guiam sua forma de viver.
              Quem é mais
              <span> racional </span>
              observa com mais distância e costuma decidir com base na lógica.
            </p>
            <p>
              Quem é mais
              <span> afetivo </span>
              sente com profundidade e se conecta com facilidade. Ambos os
              estilos têm força. O essencial é reconhecer o que você sente e
              como isso influencia suas escolhas.
            </p>
          </div>
        )}
        {step === 3 && (
          <div className={css.gridMainContainer}>
            <h1>⚡ Energia</h1>
            <h1>Contemplativo x Ativo</h1>
            <p>Essa dimensão fala sobre o seu impulso natural para agir.</p>
            <p>
              Pessoas
              <span> contemplativas </span>
              preferem observar com calma, refletir, planejar.
            </p>
            <p>
              Pessoas
              <span> ativas </span>
              gostam de movimento, novidade, iniciativa.
            </p>
            <p>
              Seu ritmo não precisa ser igual ao de ninguém — o importante é
              conhecer o seu e usá-lo com intenção.
            </p>
          </div>
        )}
        {step === 4 && (
          <div className={css.gridMainContainer}>
            <h1>🗣️ Social</h1>
            <h1>Reservado x Expansivo</h1>
            <p>
              Essa dimensão mostra como você se conecta com o mundo ao redor.
            </p>
            <p>
              <span> Reservados </span>
              preferem vínculos mais íntimos e tempo de qualidade a sós.
            </p>
            <p>
              <span> Expansivos </span>
              se sentem à vontade em interações sociais e se energizam com
              companhia.
            </p>
            <p>
              Você pode ser um pouco de cada. O essencial é saber o que te nutre
              e respeitar seus limites.
            </p>
          </div>
        )}
        {step === 5 && (
          <div className={css.gridMainContainer}>
            <p>
              Agora, conheceremos as dimensões do
              <span> Caráter.</span>
            </p>
            <h1>
              🧠 Como você regula suas ações, decisões e interpretações com o
              tempo.
            </h1>
          </div>
        )}
        {step === 6 && (
          <div className={css.gridMainContainer}>
            <h1>🧭 Regras</h1>
            <h1>Espontâneo x Disciplinado</h1>
            <p>
              Essa dimensão mostra como você lida com regras, rotinas e
              compromissos.
            </p>
            <p>
              <span> Espontâneos </span>
              preferem agir com liberdade e seguir o fluxo.
            </p>
            <p>
              <span> Disciplinados </span>
              se sentem melhor com planejamento, ordem e constância.
            </p>
            <p>
              Encontrar equilíbrio entre liberdade e estrutura pode ser uma
              grande força.
            </p>
          </div>
        )}
        {step === 7 && (
          <div className={css.gridMainContainer}>
            <h1>🌀 Raciocínio</h1>
            <h1>Pragmático x Imaginativo</h1>
            <p>Essa dimensão descreve como você interpreta o mundo.</p>
            <p>
              <span> Pragmáticos </span>
              preferem soluções práticas e testadas.
            </p>
            <p>
              <span> Imaginativos </span>
              enxergam novas possibilidades e criam com facilidade.
            </p>
            <p>
              Ambos os lados podem trabalhar juntos — inovar com os pés no chão.
            </p>
          </div>
        )}
        {step === 8 && (
          <div className={css.gridMainContainer}>
            <h1>🌿 Flexibilidade emocional</h1>
            <h1>Intenso x Assertivo</h1>
            <p>
              Essa dimensão fala sobre como você lida com desconfortos internos.
            </p>
            <p>
              <span> Intensos </span>
              sentem com força e reagem mais diretamente às emoções.
            </p>
            <p>
              <span> Assertivos </span>
              conseguem manter foco e agir com equilíbrio mesmo em momentos
              difíceis.
            </p>
            <p>
              Esse é um dos traços mais importantes para sustentar mudanças com
              coragem e cuidado.
            </p>
          </div>
        )}
        {step === 9 && (
          <>
            <p>
              Agora que você entendeu sobre as dimensões da personalidade, vamos
              fazer uma atividade sobre seu estilo pessoal com base no
              questionário que realizamos antes.
            </p>
            <h1>“Quais padrões fazem parte do seu temperamento?”</h1>
            <div>
              <div
                className={checkChoice("rational") ? css.cardActive : css.card}
                onClick={() => setAnswer1("rational")}
              >
                Racional
              </div>
              <div
                className={checkChoice("affective") ? css.cardActive : css.card}
                onClick={() => setAnswer1("affective")}
              >
                Afetivo
              </div>
              <div
                className={
                  checkChoice("contemplative") ? css.cardActive : css.card
                }
                onClick={() => setAnswer2("contemplative")}
              >
                Contemplativo
              </div>
              <div
                className={checkChoice("active") ? css.cardActive : css.card}
                onClick={() => setAnswer2("active")}
              >
                Ativo
              </div>
              <div
                className={checkChoice("reserved") ? css.cardActive : css.card}
                onClick={() => setAnswer3("reserved")}
              >
                Reservado
              </div>
              <div
                className={checkChoice("expansive") ? css.cardActive : css.card}
                onClick={() => setAnswer3("expansive")}
              >
                Expansivo
              </div>
            </div>
            <h1>“Quais padrões fazem parte do seu caráter?”</h1>
            <div>
              <div
                className={
                  checkChoice("spontaneous") ? css.cardActive : css.card
                }
                onClick={() => setAnswer4("spontaneous")}
              >
                Espontâneo
              </div>
              <div
                className={
                  checkChoice("disciplined") ? css.cardActive : css.card
                }
                onClick={() => setAnswer4("disciplined")}
              >
                Disciplinado
              </div>
              <div
                className={checkChoice("pragmatic") ? css.cardActive : css.card}
                onClick={() => setAnswer5("pragmatic")}
              >
                Pragmático
              </div>
              <div
                className={
                  checkChoice("imaginative") ? css.cardActive : css.card
                }
                onClick={() => setAnswer5("imaginative")}
              >
                Imaginativo
              </div>
              <div
                className={checkChoice("intense") ? css.cardActive : css.card}
                onClick={() => setAnswer6("intense")}
              >
                Intenso
              </div>
              <div
                className={checkChoice("assertive") ? css.cardActive : css.card}
                onClick={() => setAnswer6("assertive")}
              >
                Assertivo
              </div>
            </div>
          </>
        )}
        {step === 10 && (
          <>
            <h1>
              Abaixo estão suas escolhas e o resultado da avaliação. Você marcou{" "}
              {checkCorrects()} conforme o resultado do questionário.
            </h1>
            <p>
              Lembre-se: o autoconhecimento ajuda a melhorar seu comportamento.
            </p>
            <table>
              <thead>
                <tr>
                  <th scope="col">Dimensão</th>
                  <th scope="col">Escolhas</th>
                  <th scope="col">Questionário</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Emoção</th>
                  <td>
                    <p>{answer1 === "affective" ? "Afetivo" : "Racional"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[0] * 100) / 35) >
                      50
                        ? "Afetivo"
                        : "Racional"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Energia</th>
                  <td>
                    <p>{answer2 === "active" ? "Ativo" : "Contemplativo"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[1] * 100) / 35) >
                      50
                        ? "Ativo"
                        : "Contemplativo"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Sociabilidade</th>
                  <td>
                    <p>{answer3 === "expansive" ? "Expansivo" : "Reservado"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[2] * 100) / 35) >
                      50
                        ? "Expansivo"
                        : "Reservado"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Regras</th>
                  <td>
                    <p>
                      {answer4 === "disciplined"
                        ? "Disciplinado"
                        : "Espontâneo"}
                    </p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[3] * 100) / 40) >
                      50
                        ? "Disciplinado"
                        : "Espontâneo"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Imaginação</th>
                  <td>
                    <p>
                      {answer5 === "imaginative" ? "Imaginativo" : "Pragmático"}
                    </p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[4] * 100) / 50) >
                      50
                        ? "Imaginativo"
                        : "Pragmático"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Assertividade</th>
                  <td>
                    <p>{answer6 === "assertive" ? "Assertivo" : "Intenso"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[5] * 100) / 50) >
                      50
                        ? "Assertivo"
                        : "Intenso"}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        )}
        {step === 11 && (
          <div className={css.gridMainContainer}>
            <h1>Você, por inteiro</h1>
            <p>
              Essas seis dimensões não te colocam em caixinhas. Elas revelam
              possibilidades.
            </p>
            <p>Você pode ser flexível. Pode mudar. Pode crescer.</p>
            <p>
              Mas também pode aprender a usar suas forças do jeito que elas já
              são.
            </p>
            <p>Autoconhecimento é isso: menos julgamento, mais direção.</p>
          </div>
        )}
      </section>
      <div>
        <section className={css.gridOptions}>
          {step > 0 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step - 1);
              }}
            >
              Anterior
            </button>
          ) : (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Anterior
            </button>
          )}
          {step === 9 ? (
            answer1 && answer2 && answer3 && answer4 && answer5 && answer6 ? (
              <button
                className={`greenButton ${css.button}`}
                onClick={() => {
                  setStep(step + 1);
                }}
              >
                Próximo
              </button>
            ) : (
              <button className={`greenButton ${css.buttonDisabled}`}>
                Próximo
              </button>
            )
          ) : step === stepLength ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                finish();
              }}
            >
              Finalizar
            </button>
          ) : (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          )}
        </section>
      </div>
    </div>
  );
};
